import React from "react";
import { Card, Form, Button, ListGroup, Badge } from "react-bootstrap";
import { Calendar, Plus, Settings } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux.js";
import { t } from "i18next";
import {
  changeView,
  toggleAgenda,
} from "../../../store/features/calendar/calendarActions.js";
import { openModal } from "../../../store/features/ui/uiActions.js";
import { MODAL_TYPES } from "../../../store/features/ui/uiTypes.js";
import { CALENDAR_VIEWS } from "../../../store/features/calendar/calendarTypes.js";

const CalendarSidebar = () => {
  const dispatch = useAppDispatch();
  const { selectedAgendas } = useAppSelector((state) => state.calendar);
  const { items: agendas, loading } = useAppSelector((state) => state.agendas);
  const { role } = useAppSelector((state) => state.auth);

  const handleAgendaToggle = (agendaId) => {
    dispatch(toggleAgenda(agendaId));
  };

  const handleBookAppointment = () => {
    dispatch(openModal(MODAL_TYPES.BOOK_APPOINTMENT));
  };

  const handleAgendaSettings = () => {
    dispatch(openModal(MODAL_TYPES.AGENDA_SETTINGS));
  };
  const handleViewChange = (newView) => {
    dispatch(changeView(newView));
  };
  return (
    <div className="" style={{ backgroundColor: "#fff", borderRadius: "8px" }}>
      <div className="d-flex align-items-center justify-content-between mb-3 p-2">
        <h6 className="mb-0 fw-bold">
          <Calendar size={20} className="me-2" />
          Calendars
        </h6>
        {(role === "Admin" || role === "Advisor") && (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleAgendaSettings}
          >
            <Settings size={14} />
          </Button>
        )}
      </div>

      <Button
        variant="primary"
        size="sm"
        className="w-100 mb-3 btn-custom"
        onClick={handleBookAppointment}
      >
        <Plus size={16} className="me-1" />
        Book Appointment
      </Button>

      <Card>
        <Card.Header>
          <small className="text-muted fw-medium">MY CALENDARS</small>
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center py-3">
              <div className="loading-spinner me-2"></div>
              <small>Loading...</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {agendas.map((agenda) => (
                <ListGroup.Item
                  key={agenda.id}
                  className="d-flex align-items-center border-0 py-2 px-2"
                >
                  <Form.Check
                    type="checkbox"
                    checked={selectedAgendas.includes(agenda.id)}
                    onChange={() => handleAgendaToggle(agenda.id)}
                    className="me-2"
                  />
                  <div
                    className="rounded-circle me-2"
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: agenda.color,
                    }}
                  ></div>
                  <div className="flex-grow-1">
                    <small className="fw-medium">{agenda.name}</small>
                    <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                      {agenda.description}
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>

      <Card className="mt-3">
        <Card.Header>
          <small className="text-muted fw-medium">QUICK ACTIONS</small>
        </Card.Header>
        <Card.Body className="p-2">
          <div className="d-grid gap-2">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => handleViewChange(CALENDAR_VIEWS.DAY)}
            >
              Today's Meetings
            </Button>
            {/* <Button variant="outline-success" size="sm">
              Upcoming Meetings
            </Button>
            {role === "Admin" && (
              <Button variant="outline-info" size="sm">
                Manage Users
              </Button>
            )} */}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CalendarSidebar;
